import AppTour from 'app/tour/AppTour';
import MetricViewerTour from 'app/tour/app-tours/MetricViewerTour';
import HomePageTour from 'app/tour/app-tours/HomePageTour';
import ExternalReportViewerTour from 'app/tour/app-tours/ExternalReportViewerTour';

export const TourRouteMap = new Map<string, typeof AppTour>([
    [MetricViewerTour.tourName, MetricViewerTour],
    [HomePageTour.tourName, HomePageTour],
    [ExternalReportViewerTour.tourName, ExternalReportViewerTour],
]);
